export default __webpack_public_path__ + "static/media/Suviba.4ab6c09d.png";